/**
 * How a fixed bid's markup reads on screen (components/FixedBidMarkup.tsx and the lists that
 * show a SOW's or proposal's price). The arithmetic is utils/fixedBidMarkup.ts.
 */
import type { FixedBidQuote } from './fixedBidMarkup';

export function formatDollars(n: number): string {
  return `$${Math.round(n).toLocaleString('en-US')}`;
}

/** The breakdown after a total in a list: " (base $47,400 + 10% markup $4,740)", or nothing without a markup. */
export function markupNote(quote: FixedBidQuote | null): string {
  return quote && quote.percent > 0 ? ` (base ${formatDollars(quote.base)} + ${quote.percent}% markup ${formatDollars(quote.markup)})` : '';
}
